var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.99942,
    y: 9,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E41818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2858 29.489L17.9405 31.1436C18.1187 31.3218 18.2714 31.3218 18.4496 31.1436L22.7007 26.8925L26.85 31.0418C27.0282 31.22 27.1555 31.1945 27.3337 31.0163L28.8101 29.5399C28.9883 29.3617 29.0138 29.2344 28.8356 29.0562L24.6863 24.9069L28.9374 20.6558C29.1156 20.4776 29.1156 20.3249 28.9374 20.1467L27.2828 18.492C27.0791 18.2884 26.9264 18.2884 26.7482 18.4666L22.4971 22.7177L18.3478 18.5684C18.1696 18.3902 18.0423 18.4157 17.8641 18.5939L16.3877 20.0703C16.2095 20.2485 16.184 20.3758 16.3622 20.554L20.5115 24.7033L16.2604 28.9544C16.0567 29.158 16.0822 29.2853 16.2858 29.489Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.ac4c00899bb16ebc235876b7daf7beb2.svg";
export { ForwardRef as ReactComponent };